import type {
  UpsertDocumentMutation,
  UpsertDocumentMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const UPSERT_DOCUMENT: TypedDocumentNode<
  UpsertDocumentMutation,
  UpsertDocumentMutationVariables
> = gql`
  mutation UpsertDocument($input: UpsertDocumentInput!) {
    upsertDocument(input: $input) {
      document {
        id
        path
        userId
        context
        value
        format
        formatValidation
        createdAt
        updatedAt
        documentHistory {
          id
          value
          documentId
          changedByUserId
          changedBy {
            displayName
            gravatarHash
          }
          createdAt
        }
      }
      wasCreated
      documentMetadata {
        editTimestamp
      }
    }
  }
`;
